import { createTheme } from "@mui/material/styles";


const theme = createTheme({
    palette: {
        mode: "dark",
        primary: {
            main: "#bb86fc", // Lighter purple for dark mode
        },
        secondary: {
            main: "#9ca3af", // Gray
        },
        background: {
            default: "#121212", // Dark background
            paper: "#1e1e1e", // Slightly lighter dark background for cards
        },
        text: {
            primary: "#e0e0e0", // Light gray text for readability
            secondary: "#a1a1a1", // Dimmed gray text
        },
    },
    typography: {
        fontFamily: "Roboto, Arial, sans-serif",
    },
});

export { theme };